module.exports = __webpack_public_path__ + "img/arrow-down.f9583d0b.svg";